import { Breadcrumb, Col, Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Element, Link as LinkScroll } from "react-scroll";

import DetailContact from "components/DetailContact";
import FadeInSection from "components/FadeInSection";
import ListImage from "components/ListImage";
import LoadingSpin from "components/Loading";
import NumberImage from "components/NumberImage";
import ScrollUpBtn from "components/ScrollUpBtn";
import TableGPAX from "components/TableGPAX";
import TableRe from "components/TableRe";

import { breadcrumbName } from "core/util/common";
import { getPagePayload, getTableGpaPayload } from "years";

import mainRegis from "assets/images/png/illus-maindata_reg.png";
import system1 from "assets/images/svg/H67-1.svg";
import system2 from "assets/images/svg/H67-2.svg";
import system3 from "assets/images/svg/H67-3.svg";
import system4 from "assets/images/svg/H67-4.svg";
import system5 from "assets/images/svg/H67-5.svg";
import system6 from "assets/images/svg/H67-6.svg";
import system7 from "assets/images/svg/H67-7.svg";
import system8 from "assets/images/svg/H67-8.svg";
import downloadIcon from "assets/images/svg/icon-file-download.svg";

import form1 from "assets/images/png/illus-maindata_H70.png";
import form2 from "assets/images/png/illus-maindata_H71.png";

import select1 from "assets/images/png/illus-maindata_H28-1.png";
import select2 from "assets/images/png/illus-maindata_H28-2.png";

import regisGrade from "assets/images/png/illus-maindata_H79.png";
import regisGrade1 from "assets/images/png/illus-maindata_H80.png";
import regisGrade2 from "assets/images/png/illus-maindata_H81.png";
import regisHome from "assets/images/png/regis-home.png";

import circleIcon from "assets/images/png/icon-circle.png";
import ellipse1 from "assets/images/svg/Ellipse 31.svg";
import ellipse2 from "assets/images/svg/Ellipse 32.svg";
import noteIcon from "assets/images/svg/H73-1.svg";
import eyeIcon from "assets/images/svg/H73-2.svg";
import returnIncon from "assets/images/svg/H76.svg";
import bullet from "assets/images/svg/bullet.svg";
import rectangle1 from "assets/images/svg/rectangle-39.svg";

import regisCredit1 from "assets/images/jpg/regisCredit1.jpg";
import regisCredit2 from "assets/images/jpg/regisCredit2.jpg";
import regisCredit3 from "assets/images/jpg/regisCredit3.jpg";
import regisCredit4 from "assets/images/jpg/regisCredit4.jpg";
import regisCredit5 from "assets/images/jpg/regisCredit5.jpg";
import regisCredit6 from "assets/images/jpg/regisCredit6.jpg";

import {
  Box,
  Container,
  ContainerCard,
  CustomCarousel,
  CusttomBreadcrumb,
  Detail,
  FixBox,
  Line,
  ListImages,
  NumberList,
  Numbers,
  SubHead,
  TextDetail,
  TextHead,
  TextNumber,
  TextSection,
  TextTitle,
  Title,
  TitleEN,
  TttleSelect,
} from "./registration.style";

const Registration = ({ year }) => {
  const myRef = useRef();
  const { pathname } = useLocation();
  const splitPath = pathname.split("/") || [];
  splitPath.shift();

  const [regisData, setRegisData] = useState([]);
  const [gradeData1, setGradeData1] = useState([]);
  const [gradeData2, setGradeData2] = useState([]);
  const [gradeData3, setGradeData3] = useState([]);
  const [meanData, setMeanData] = useState([]);
  const [reEntryData, setReEntryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const newPath = (route) => {
    let path = "";
    const orderRoute = splitPath.indexOf(route);
    splitPath.map((item, i) => i <= orderRoute && (path += `/${item}`));

    return path;
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    getDataRegis();
    getCalGrade1();
    getCalGrade2();
    getCalGrade3();
    getMeanGrade();
    getDataReEntry();
  }, [year]);

  const scrollToComponent = async () => {
    let element =
      (await document.getElementById(splitPath[1])?.offsetTop) - 132;
    window.scrollTo(0, element);
  };

  useEffect(() => {
    scrollToComponent();
  }, [myRef.current]);

  const getDataRegis = () => {
    setIsLoading(false);
    const response = { data: getPagePayload(year, "how_to_register") };

    if (response?.data?.code === 200) {
      const data = response?.data?.data;
      setIsLoading(true);
      setRegisData(data);
    } else {
      setIsLoading(true);
      setRegisData([]);
    }
  };

  const getCalGrade1 = () => {
    const response = { data: getTableGpaPayload(year, "1") };

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setGradeData1(data);
    } else {
      setGradeData1([]);
    }
  };

  const getCalGrade2 = () => {
    const response = { data: getTableGpaPayload(year, "2") };

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setGradeData2(data);
    } else {
      setGradeData2([]);
    }
  };

  const getCalGrade3 = () => {
    const response = { data: getTableGpaPayload(year, "3") };

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setGradeData3(data);
    } else {
      setGradeData3([]);
    }
  };

  const getMeanGrade = () => {
    const response = { data: getPagePayload(year, "table_grade") };

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setMeanData(data);
    } else {
      setMeanData([]);
    }
  };

  const getDataReEntry = () => {
    const response = { data: getPagePayload(year, "table_retry") };

    if (response?.data?.code === 200) {
      const data = response?.data?.data;

      setReEntryData(data);
    } else {
      setReEntryData([]);
    }
  };

  const renderLink = (to, name) => {
    return (
      <LinkScroll
        activeClass="active"
        to={to}
        spy={true}
        smooth={true}
        duration={500}
        offset={-130}
      >
        <div style={{ display: "flex" }}>
          <img
            loading="lazy"
            src={bullet}
            alt="bullet icon"
            style={{
              width: "20px",
              height: "20px",
              margin: "10px 10px 0 0",
            }}
          />
          <TextSection>{name}</TextSection>
        </div>
      </LinkScroll>
    );
  };

  const styleImage = {
    maxWidth: "100%",
    margin: "20px 0",
  };

  const styleStart = { display: "flex", alignItems: "start" };

  const splitName = (text, position) => {
    const word = text.split("/n");

    return word[position];
  };

  const spliteLink = (link, title) => {
    const newLink = title.split(" ");
    return (
      <div className="link-web">
        {newLink[0]}
        <a href={link} target="_blank" rel="noreferrer">
          <u>{newLink[1]}</u>
        </a>
      </div>
    );
  };

  const listImage1 = (src, text) => {
    return (
      <ListImages>
        <img
          src={src}
          alt="register system"
          style={{ height: "170px" }}
          loading="lazy"
        />
        <Detail align="left">{text}</Detail>
      </ListImages>
    );
  };

  const renderNumberList = (item, link, website) => {
    return (
      <>
        {item.slung === "registration-fees" ? (
          <NumberList>
            <NumberImage number={1} position={0} />
            ลงทะเบียนตามปกติ
          </NumberList>
        ) : (
          item?.conent_0 && (
            <NumberList>
              <NumberImage number={1} position={0} />
              {item?.conent_0}
            </NumberList>
          )
        )}

        {item.slung === "registration-fees" ? (
          <Box>
            <NumberList icon={true}>
              <NumberImage number={2} position={45} />
              <div style={{ display: "grid" }}>
                กรอกข้อมูล
                <a href={link} target="_blank" rel="noreferrer" download>
                  <img
                    loading="lazy"
                    src={downloadIcon}
                    alt="icon download file"
                    style={{ marginRight: "10px", height: "32px" }}
                  />
                  <span>เลือกดาวน์โหลดแบบฟอร์ม ท.21</span>
                </a>
              </div>
            </NumberList>
          </Box>
        ) : (
          item?.conent_1 && (
            <Box>
              <NumberList icon={true}>
                <NumberImage number={2} position={45} />
                <div style={{ display: "grid" }}>
                  {item?.conent_1}
                  <a href={link} target="_blank" rel="noreferrer" download>
                    <img
                      loading="lazy"
                      src={downloadIcon}
                      alt="icon download file"
                      style={{ marginRight: "10px", height: "32px" }}
                    />
                    <span>ดาวน์โหลดแบบฟอร์ม</span>
                  </a>
                </div>
              </NumberList>
            </Box>
          )
        )}

        {item.slung === "registration-fees" ? (
          <NumberList>
            <NumberImage number={3} position={90} />
            นำคำร้องให้อาจารย์ที่ปรึกษาพิจารณา
            และส่งคำร้องที่ฝ่ายทะเบียนนักศึกษา ที่อาคารเรียนรวม 2
          </NumberList>
        ) : (
          item?.conent_2 && (
            <NumberList>
              <NumberImage number={3} position={90} />
              {item?.conent_2}
            </NumberList>
          )
        )}

        {item.slung === "registration-fees" ? (
          <NumberList>
            <NumberImage number={4} position={180} />
            <span>
              ตรวจสอบผลการพิจารณาได้ที่{" "}
              <span className="custom-color">reg.sut.ac.th</span> ที่เมนู{" "}
              <span className="custom-color">“ภาระค่าใช้จ่ายทุน”</span> ช่อง{" "}
              <span className="custom-color">“วันผ่อนชำระ”</span>{" "}
              จะปรากฏวันที่ได้รับอนุมัติให้ผ่อนผันฯ
            </span>
          </NumberList>
        ) : item?.conent_3 && website ? (
          <NumberList>
            <NumberImage number={4} position={180} />
            {spliteLink(website, item?.conent_3, " ")}
          </NumberList>
        ) : (
          <NumberList>
            <NumberImage number={4} position={180} />
            {item?.conent_3}
          </NumberList>
        )}
      </>
    );
  };

  const renderSystem = (item) => {
    return (
      <Element name={item?.slung} id={item?.slung} ref={myRef}>
        <TextTitle top="10%">{item?.sub_title}</TextTitle>
        <Row gutter={[24, 24]} className="row-system">
          <Col span={12}>{listImage1(system1, item?.conent_0)}</Col>
          <Col span={12}>{listImage1(system2, item?.conent_1)}</Col>
          <Col span={12}>{listImage1(system3, item?.conent_2)}</Col>
          <Col span={12}>{listImage1(system4, item?.conent_3)}</Col>
          <Col span={12}>{listImage1(system5, item?.conent_4)}</Col>
          <Col span={12}>{listImage1(system6, item?.conent_5)}</Col>
          <Col span={12}>{listImage1(system7, item?.conent_6)}</Col>
          <Col span={12}>{listImage1(system8, item?.conent_7)}</Col>
        </Row>
      </Element>
    );
  };

  const renderCredits = (item) => {
    return (
      <Element name={item?.slung} id={item?.slung} ref={myRef}>
        <TextTitle top="10%">{item?.sub_title}</TextTitle>
        {item?.conent_0 && (
          <TextDetail indent="32">{item?.conent_0}</TextDetail>
        )}

        <Row gutter={[24, 24]} className="row-section">
          <Col span={8}>
            <NumberImage number={1} position={0} />
            <img
              src={regisCredit1}
              alt="register credits"
              style={styleImage}
              loading="lazy"
            />
            <SubHead>
              <span>
                ยื่นคำร้องผ่าน{" "}
                <span style={{ color: "#EC6547" }}>reg.sut.ac.th</span> ที่เมนู{" "}
                <span style={{ color: "#EC6547" }}>“ลงทะเบียนเพิ่มลด”</span>{" "}
                ก่อนหมดกำหนดเพิ่มรายวิชา 1 วัน
              </span>
              {/* <a
                href="http://web.sut.ac.th/ces/2018/ces/formST/14.pdf"
                target="_blank"
                rel="noreferrer"
                download
              >
                <img
                  src={downloadIcon}
                  alt="icon download file"
                  loading="lazy"
                />
                ดาวน์โหลดแบบฟอร์ม
              </a> */}
            </SubHead>
          </Col>
          <Col span={8}>
            <NumberImage number={2} position={45} />
            <img
              src={regisCredit2}
              alt="register credits"
              style={styleImage}
              loading="lazy"
            />
            <SubHead>
              <span>
                เลือกรายการ{" "}
                <span style={{ color: "#EC6547" }}>“เพิ่มรายวิชา”</span> หรือ
                “เปลี่ยนกลุ่ม”
              </span>
            </SubHead>
            {/* {item?.conent_1 && <TextDetail>{item?.conent_1}</TextDetail>} */}
          </Col>
          <Col span={8}>
            <NumberImage number={3} position={90} />
            <img
              src={regisCredit3}
              alt="register credits"
              style={styleImage}
              loading="lazy"
            />
            <SubHead>
              <span>
                ใส่รหัสวิชา {">"} กด Enter {">"} เลือกกลุ่มเรียน
              </span>
            </SubHead>
            {/* {item?.conent_4 && <TextDetail>{item?.conent_4}</TextDetail>} */}
          </Col>
        </Row>
        <Row gutter={[24, 24]} className="row-section">
          <Col span={8}>
            <NumberImage number={4} position={0} />
            <img
              src={regisCredit4}
              alt="register credits"
              style={styleImage}
              loading="lazy"
            />
            <SubHead>
              <span>
                หากปรากฏข้อความ “ที่นั่งกันสำรองเต็มแล้ว/ไม่มีที่นั่งอื่นเหลือ”
                ให้ตรวจสอบรายวิชาอีกครั้ง แล้วให้เลือกเมนู{" "}
                <span style={{ color: "#EC6547" }}>“ยื่นคำร้องออนไลน์”</span>
              </span>
            </SubHead>
          </Col>
          <Col span={8}>
            <NumberImage number={5} position={45} />
            <img
              src={regisCredit5}
              alt="register credits"
              style={styleImage}
              loading="lazy"
            />
            <SubHead>
              <span>
                จากนั้น จะปรากฏรายวิชาที่ต้องการลงเพิ่ม/เปลี่ยนกลุ่ม
                ให้ตรวจสอบอีกครั้ง หากต้องการยื่นคำร้อง ให้เลือกเมนู{" "}
                <span style={{ color: "#EC6547" }}>“ทำรายการ”</span> {">"}{" "}
                ระบุเหตุผล
              </span>
            </SubHead>
          </Col>
          <Col span={8}>
            <NumberImage number={6} position={90} />
            <img
              src={regisCredit6}
              alt="register credits"
              style={styleImage}
              loading="lazy"
            />
            <SubHead>
              <span>
                เมื่อทำรายการเสร็จ ให้นักศึกษาติดตามคำร้อง โดยเลือกเมนู{" "}
                <span style={{ color: "#EC6547" }}>“ติดตามผลขอเพิ่มถอน”</span>{" "}
                และตรวจสอบผลได้ที่เมนู{" "}
                <span style={{ color: "#EC6547" }}>“ผลการลงทะเบียน”</span>
              </span>
            </SubHead>
          </Col>

          <div style={{ whiteSpace: "pre-line", wordWrap: "normal" }}>
            <ListImage
              noteText={`
                1) ให้นักศึกษาตรวจสอบจำนวนที่นั่งคงเหลือในกลุ่มเรียนก่อน หากกลุ่มเต็ม ให้ยื่นคำร้องขอเพิ่มรายวิชา/เปลี่ยนกลุ่ม กรณีกลุ่มเต็ม/ลดรายวิชา (ท.1)
                2) ตรวจสอบวันเวลาเรียน - เวลาสอบ
                3) ทั้งนี้การลงทะเบียนเรียนต้องไม่เกิน 28 หน่วยกิต
                4) นอกจากนี้ หากในภาคการศึกษานั้นไม่มีหน่วยกิตเรียน ต้องดำเนินการลาพักการศึกษา หรือรักษาสถานภาพ
                `}
              type="note"
              font="Noto Sans Thai"
            />
          </div>
        </Row>
      </Element>
    );
  };

  const renderGPAX = (item) => {
    return (
      <Element name={item?.slung} id={item?.slung} ref={myRef}>
        <FixBox bg="#FFF9EA">
          <TextTitle top="0">{item?.sub_title}</TextTitle>

          <Row gutter={[24, 24]} className="row-contact">
            <Col span={8}>
              <FadeInSection axis="x">
                <ContainerCard>
                  <img
                    loading="lazy"
                    src={item?.image ? item?.image : form1}
                    alt="leave condition"
                    style={styleImage}
                  />
                </ContainerCard>
              </FadeInSection>
            </Col>
            <Col span={15} offset={1} className="col-leave">
              {renderNumberList(
                item,
                "http://web.sut.ac.th/ces/2018/ces/formST/14.pdf"
              )}
              {item?.conent_4 && (
                <ListImage
                  noteText={item?.conent_4}
                  type="note"
                  font="Noto Sans Thai"
                />
              )}
            </Col>
          </Row>
        </FixBox>
      </Element>
    );
  };

  const renderFees = (item) => {
    return (
      <Element name={item?.slung} id={item?.slung} ref={myRef}>
        <TextTitle top="10%">{item?.sub_title}</TextTitle>
        {item?.conent_0 && (
          <TextDetail indent="32">{item?.conent_0}</TextDetail>
        )}
        <Row gutter={[24, 24]} className="row-contact ">
          <Col span={15} className="col-leave">
            {renderNumberList(
              item,
              "http://sutgateway.sut.ac.th/ces/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2/download-%e0%b8%84%e0%b8%b3%e0%b8%a3%e0%b8%ad%e0%b8%87/",
              "http://sutgateway.sut.ac.th/ces/"
            )}
          </Col>
          <Col span={8} offset={1}>
            <FadeInSection axis="y">
              <ContainerCard>
                <img
                  loading="lazy"
                  src={item?.image ? item?.image : form2}
                  alt="leave condition"
                  style={styleImage}
                />
              </ContainerCard>
            </FadeInSection>
          </Col>
          {/* {item?.conent_4 && (
            <ListImage
              noteText={item?.conent_4}
              type="note"
              font="Noto Sans Thai"
            />
          )} */}
          <div style={{ whiteSpace: "pre-line", wordWrap: "normal" }}>
            <ListImage
              noteText={`
                Warning
                1) หากไม่พบข้อมูลวันผ่อนชำระฯ ให้ติดต่อฝ่ายทะเบียนนักศึกษา อาคารเรียนรวม 2 โทร 0-4422-3016-7 
                2) นักศึกษาที่ได้รับทุนการศึกษา หากรอผลประกาศทุนการศึกษาให้ยื่นคำร้องขอผ่อนผันฯ ทุก 4 สัปดาห์ จนกว่าจะมีประกาศทุนการศึกษาจากมหาวิทยาลัยเทคโนโลยีสุรนารี พร้อมแนบเอกสารเสนอชื่อเพื่อรับทุนมาด้วย
                `}
              type="note"
              font="Noto Sans Thai"
            />
          </div>
        </Row>
      </Element>
    );
  };

  const renderSelection = (item) => {
    return (
      <Element name={item?.slung} id={item?.slung} ref={myRef}>
        <FixBox bg="#FFF9EA">
          <TextTitle top="0">{item?.sub_title}</TextTitle>
          <Row gutter={[24, 24]} className="row-system">
            <Col span={12}>
              <NumberImage number={1} position={0} />
              <FadeInSection axis="y">
                <img
                  src={select1}
                  alt="register credits"
                  style={styleImage}
                  loading="lazy"
                />
              </FadeInSection>
              <TextHead>{item?.conent_0}</TextHead>
              <Detail align="left" bottom="0">
                {item?.conent_1}
              </Detail>
              <Detail align="left" top="0">
                {item?.conent_2}
              </Detail>
            </Col>
            <Col span={12}>
              <NumberImage number={2} position={45} />
              <FadeInSection axis="y">
                <img
                  src={select2}
                  alt="register credits"
                  style={styleImage}
                  loading="lazy"
                />
              </FadeInSection>
              <TextHead>{item?.conent_3}</TextHead>
              <Detail align="left">{item?.conent_4}</Detail>
            </Col>
          </Row>

          <TttleSelect>{item?.conent_5 && item?.conent_5}</TttleSelect>
          {item?.conent_6 && item?.conent_7 && (
            <Detail>
              {item?.conent_6}
              {item?.conent_7}
            </Detail>
          )}
          <Line />
          <TttleSelect>{item?.conent_8 && item?.conent_8}</TttleSelect>
          {item?.conent_9 && <Detail> {item?.conent_9} </Detail>}

          <Detail>
            <a
              href="http://sutgateway.sut.ac.th/ces/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2/download-%e0%b8%84%e0%b8%b3%e0%b8%a3%e0%b8%ad%e0%b8%87/"
              target="_blank"
              rel="noreferrer"
              download
            >
              <img
                loading="lazy"
                src={downloadIcon}
                alt="icon download file"
                style={{ margin: "0 20px", height: "32px" }}
              />
              <span>เลือกดาวน์โหลดแบบฟอร์ม ท.9</span>
            </a>
          </Detail>

          {item?.conent_11 && (
            <ListImage
              noteText={item?.conent_11}
              type="note"
              font="Noto Sans Thai"
            />
          )}
        </FixBox>
      </Element>
    );
  };

  const renderGrade = (item) => {
    return (
      <Element name={item?.slung} id={item?.slung} ref={myRef}>
        <Row
          gutter={24}
          style={{ marginTop: "10%" }}
          className="row-col-branch"
        >
          <Col span={11}>
            <FadeInSection axis="x">
              <CustomCarousel autoplay bg="#FAA378">
                <img
                  loading="lazy"
                  src={regisHome}
                  alt="icon group"
                  style={{ borderRadius: "20px", width: "100%" }}
                />
              </CustomCarousel>
            </FadeInSection>
          </Col>
          <Col span={12} offset={1}>
            <TextTitle>{item?.sub_title}</TextTitle>
            <TextHead>
              <img
                loading="lazy"
                src={circleIcon}
                alt="icon circle"
                style={{
                  zIndex: "-1",
                  position: "absolute",
                  left: "-50px",
                  top: "-40px",
                }}
              />
              {item?.sub_title}
            </TextHead>

            <div style={{ display: "flex", alignItems: "center" }}>
              <TextNumber>1</TextNumber>
              <TextDetail>
                เข้าเว็บไซต์ลงทะเบียน
                <a
                  href={`https://reg.sut.ac.th`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <u>reg.sut.ac.th</u>
                </a>
              </TextDetail>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <TextNumber>2</TextNumber>
              <TextDetail>
                Click เมนู <b>“เข้าสู่ระบบ”</b>
              </TextDetail>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <TextNumber>3</TextNumber>
              <TextDetail>
                Click เมนู <b>“ผลการศึกษา”</b>
              </TextDetail>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              <TextNumber>4</TextNumber>
              <TextDetail>
                Click เมนู <b>ใช้โปรแกรมทดสอบเกรด</b>
              </TextDetail>
            </div>
          </Col>
        </Row>

        <Row
          gutter={24}
          style={{ marginTop: "10%" }}
          className="row-col-branch"
        >
          <Col span={12}>
            <TextHead>
              <img
                loading="lazy"
                src={circleIcon}
                alt="icon circle"
                style={{
                  zIndex: "-1",
                  position: "absolute",
                  left: "-50px",
                  top: "-40px",
                }}
              />
              ความหมายของเกรด
            </TextHead>
            <TableGPAX key="grade-meaning" col={3} data={meanData} />

            <ListImage
              noteText="Note: *แก้เกรดภายใน 1 สัปดาห์ หลังเปิดเทอมถัดไป **แก้เกรดภายใน 1 สัปดาห์ หลังเปิดเทอมถัดไป"
              type="note"
              font="Noto Sans Thai"
            />
          </Col>
          <Col span={11} offset={1}>
            <FadeInSection axis="y">
              <CustomCarousel autoplay bg="#FAA378">
                <img
                  loading="lazy"
                  src={regisGrade}
                  alt="icon group"
                  style={{ borderRadius: "20px", width: "100%" }}
                />
              </CustomCarousel>
            </FadeInSection>
          </Col>
        </Row>

        <Row gutter={24} style={{ marginTop: "10%" }} className="row-table">
          <Col span={6}>
            <FadeInSection axis="y">
              <CustomCarousel autoplay bg="#FAA378">
                <img
                  loading="lazy"
                  src={regisGrade1}
                  alt="icon group"
                  style={{
                    borderRadius: "20px",
                    width: "100%",
                    margin: "10px 0",
                  }}
                />
              </CustomCarousel>
            </FadeInSection>
          </Col>
          <Col span={17} offset={1}>
            <TextHead>
              <img
                loading="lazy"
                src={circleIcon}
                alt="icon circle"
                style={{
                  zIndex: "-1",
                  position: "absolute",
                  left: "-50px",
                  top: "-40px",
                }}
              />
              การคำนวณ GPA
            </TextHead>
            <Detail align="left">
              เทอม 1 ตัวอย่างการคำนวณ: สมมุติว่าลงทะเบียนและได้รับผลการเรียน
              ดังนี้
            </Detail>

            <TableGPAX
              key="grade-point"
              col={6}
              sum={11}
              point={17}
              data6={gradeData1}
              colorSum="#FFF9EA"
            />
            <Detail align="left">
              หน่วยกิตที่นับ เทอม 1 = 11, Grade Point ที่ได้ = 17 <br />
              เกรดเฉลี่ย (GPA) เทอม 1 = 17/11 = 1.54
            </Detail>
            <div style={{ padding: "0 10%" }}>
              <Line />
            </div>
            <Detail align="left">
              เทอม 2 ลงทะเบียน Re-Grade วิชาในเทอมที่ 1 ลําดับที่ 1 2 และ 4
            </Detail>
            <TableGPAX
              key="grade-counter"
              col={6}
              sum={11}
              point={33}
              data6={gradeData2}
            />
            <Detail align="left">
              หน่วยกิตที่นับ = 11, Grade Point เทอม 1 ที่ได้ = 33 <br />
              เกรดเฉลี่ย (GPA) เทอม 2 = 11/33 = 3.00
            </Detail>
            <ListImage
              noteText="Note: *แก้เกรดภายใน 1 สัปดาห์ หลังเปิดเทอมถัดไป **แก้เกรดภายใน 1 สัปดาห์ หลังเปิดเทอมถัดไป"
              type="note"
              font="Noto Sans Thai"
            />
          </Col>
        </Row>

        <Row gutter={24} style={{ marginTop: "10%" }} className="row-table">
          <Col span={17} offset={1}>
            <TextHead>
              <img
                loading="lazy"
                src={circleIcon}
                alt="icon circle"
                style={{
                  zIndex: "-1",
                  position: "absolute",
                  left: "-50px",
                  top: "-40px",
                }}
              />
              การคำนวณ GPAX
            </TextHead>
            <Detail align="left">
              เทอม 1 ตัวอย่างการคำนวณ: สมมุติว่าลงทะเบียนและได้รับผลการเรียน
              ดังนี้
            </Detail>
            <TableGPAX
              key="grade-point-counter"
              col={6}
              sum={11}
              point={17}
              data6={gradeData3}
            />
            <Detail align="left">
              หน่วยกิตที่นับ เทอม 1 = 11, Grade Point ที่ได้ = 17 <br />
              เกรดเฉลี่ย (GPA) เทอม 1 = 17/11 = 1.54
            </Detail>
          </Col>
          <Col span={6}>
            <FadeInSection axis="y">
              <CustomCarousel autoplay bg="#FAA378">
                <img
                  loading="lazy"
                  src={regisGrade2}
                  alt="icon group"
                  style={{ borderRadius: "20px", width: "100%" }}
                />
              </CustomCarousel>
            </FadeInSection>
          </Col>
        </Row>
      </Element>
    );
  };

  const renderBranch = (item) => {
    return (
      <Element name={item?.slung} id={item?.slung} ref={myRef}>
        <FixBox bg="#FFF9EA">
          <TextTitle top="10%">{item?.sub_title}</TextTitle>
          <Row className="row-col-branch">
            <Col span={12}>
              <TextHead>
                <img
                  loading="lazy"
                  src={noteIcon}
                  alt="icon note"
                  style={{
                    zIndex: "-1",
                    position: "absolute",
                    left: "-50px",
                    top: "-35px",
                    width: "104px",
                  }}
                />
                เขียนคำร้อง ท.11
              </TextHead>
              <div style={{ display: "flex", alignItems: "center" }}>
                <TextNumber>1</TextNumber>
                <TextDetail>
                  ควรเข้าพบหัวหน้าสาขาวิชา
                  โดยด่วนที่สุดหลังการตัดสินใจว่าต้องการย้ายสาขาวิชา
                  เพื่อการทำเกรดให้ตรงตามเกณฑ์การรับเข้าสาขาวิชา ตามที่กำหนด
                </TextDetail>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <TextNumber>2</TextNumber>
                <Box>
                  {" "}
                  <div style={{ display: "grid" }}>
                    <TextDetail bottom="0px">
                      กรอกข้อมูลในแบบฟอร์ม ท.11 ให้ถูกต้อง
                      ครบถ้วนพร้อมกับแนบใบแสดงผลการศึกษา (Transcript)
                    </TextDetail>

                    <a
                      href={
                        "http://sutgateway.sut.ac.th/ces/%e0%b8%99%e0%b8%b1%e0%b8%81%e0%b8%a8%e0%b8%b6%e0%b8%81%e0%b8%a9%e0%b8%b2/download-%e0%b8%84%e0%b8%b3%e0%b8%a3%e0%b8%ad%e0%b8%87/"
                      }
                      target="_blank"
                      rel="noreferrer"
                      download
                    >
                      <img
                        loading="lazy"
                        src={downloadIcon}
                        alt="icon download file"
                        style={{ marginRight: "10px", height: "32px" }}
                      />
                      <span>เลือกดาวน์โหลดแบบฟอร์ม ท.11</span>
                    </a>
                  </div>
                </Box>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <TextNumber>3</TextNumber>
                <TextDetail>
                  นำคำร้องฯ เสนออาจารย์ที่ปรึกษาให้ความเห็นชอบ
                </TextDetail>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <TextNumber>4</TextNumber>
                <TextDetail>
                  นำคำร้องฯ ที่ได้รับความเห็นชอบจากอาจารย์ที่ปรึกษาแล้ว
                  ส่งที่ฝ่ายทะเบียนนักศึกษา อาคารเรียนรวม 2
                </TextDetail>
              </div>
              {/* <Detail align="left">
                <a
                  href="http://web.sut.ac.th/ces/2018/ces/formST/08.pdf"
                  target="_blank"
                  rel="noreferrer"
                  download
                >
                  <img
                    loading="lazy"
                    src={downloadIcon}
                    alt="icon download file"
                    style={{ margin: "0 20px", height: "32px" }}
                  />
                  <span>ดาวน์โหลดแบบฟอร์ม</span>
                </a>
              </Detail> */}
            </Col>
            <Col span={11} offset={1}>
              <TextHead>
                <img
                  loading="lazy"
                  src={eyeIcon}
                  alt="icon eye"
                  style={{
                    zIndex: "-1",
                    position: "absolute",
                    left: "-50px",
                    top: "-35px",
                    width: "104px",
                  }}
                />

                <div className="link-web">
                  ตรวจสอบเกณฑ์การย้ายเข้า/ออก
                  <a
                    href="http://reg3.sut.ac.th/registrar/home.asp?Serv=5&?avs=44769.7114583333"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <u>ที่นี่</u>
                  </a>
                </div>
              </TextHead>

              <div style={{ marginLeft: "30px" }}>
                <TextHead>
                  <img
                    loading="lazy"
                    src={ellipse2}
                    alt="icon ellipse"
                    style={{
                      zIndex: "-1",
                      position: "absolute",
                      left: "-50px",
                      top: "0px",
                    }}
                  />
                  หากเป็นไปตามเกณฑ์
                </TextHead>
                <TextDetail>
                  นำคำร้องเข้าพบ อาจารย์ที่ปรึกษาพิจารณา
                  ส่งคำร้องที่ฝ่ายทะเบียนนักศึกษา อาคารเรียนรวม 2
                </TextDetail>
              </div>
              <div style={{ marginLeft: "30px" }}>
                <TextHead>
                  <img
                    loading="lazy"
                    src={ellipse1}
                    alt="icon ellipse"
                    style={{
                      zIndex: "-1",
                      position: "absolute",
                      left: "-50px",
                      top: "0px",
                    }}
                  />
                  หากไม่เป็นไปตามเกณฑ์
                </TextHead>
                <TextDetail>
                  ยังทำเรื่องย้ายสาขาวิชาฯ ไม่ได้ จนกว่าจะเป็นไป
                  ตามเกณฑ์ของสาขาวิชา
                </TextDetail>
              </div>
            </Col>
          </Row>

          <Row className="row-col-branch" style={{ marginTop: "40px" }}>
            <Col span={12}>
              <TextHead>
                <img
                  loading="lazy"
                  src={noteIcon}
                  alt="icon note"
                  style={{
                    zIndex: "-1",
                    position: "absolute",
                    left: "-50px",
                    top: "-35px",
                    width: "104px",
                  }}
                />
                เมื่อ ท.11 ได้รับอนุมัติแล้ว จะต้องทำตามขั้นตอนดังต่อไปนี้
              </TextHead>
              <div style={{ display: "flex", alignItems: "center" }}>
                <TextNumber>1</TextNumber>
                <TextDetail>
                  ติดต่อรับคำร้องโอนย้ายรายวิชา กรณีย้ายสาขาวิชา
                  ที่ฝ่ายทะเบียนนักศึกษา ภายใน 10 วันนับจากเปิดภาคการศึกษา
                </TextDetail>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <TextNumber>2</TextNumber>
                <TextDetail>
                  นักศึกษาเลือกรายวิชาที่ต้องการโอนย้ายในหมวดเลือกเสรี ดังนี้
                  <br />
                  <span style={{ paddingLeft: "40px" }}>
                    กรอกเครื่องหมาย / ในรายวิชาที่ต้องการโอนย้าย
                  </span>{" "}
                  <br />
                  <span style={{ paddingLeft: "40px" }}>
                    {" "}
                    กรอกเครื่องหมาย X ในรายวิชาที่ไม่ต้องการโอนย้าย
                  </span>
                </TextDetail>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <TextNumber>3</TextNumber>
                <TextDetail>
                  นำคำร้องขอโอนย้ายรายวิชา เสนออาจารย์ที่ปรึกษา
                  และหัวหน้าสาขาวิชาพิจารณาอนุมัติ
                </TextDetail>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <TextNumber>4</TextNumber>
                <TextDetail>
                  นำคำร้องที่ผ่านการพิจารณาแล้ว ส่งฝ่ายทะเบียนนักศึกษา
                </TextDetail>
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <TextNumber>5</TextNumber>
                <TextDetail>
                  ตรวจสอบการบันทึกรายวิชาที่ไม่โอนย้ายในระบบทะเบียนและประมวลผล
                </TextDetail>
              </div>
            </Col>
            <Col span={11} offset={1}></Col>
          </Row>

          {/* <ListImage
            noteText="1. สอบถามสาขาวิชาฯ ที่จะย้ายเข้าว่ารับหรือไม่ ? ถ้ารับ : ต้องหาแนวทางการลงทะเบียน > ตั้งใจเรียน ทำเกรด > ทำเกรดให้เป็นไปตามที่กำหนด ถ้าไม่รับ : พบอาจารย์ที่ปรึกษา 2. พบสาขาวิชาฯ เพื่อขอคำปรึกษาเรื่อง เกณฑ์การย้ายเข้า 3. ต้องย้ายให้เสร็จภายใน 6 ภาคการศึกษา นับตั้งแต่เข้าศึกษา 4. ย้ายสาขาสามารถทำได้เพียงครั้งเดียว เท่านั้น"
            type="note"
            font="Noto Sans Thai"
          /> */}
        </FixBox>
      </Element>
    );
  };

  const rendereEtry = (item) => {
    return (
      <Element name={item?.slung} id={item?.slung} ref={myRef}>
        <TextTitle top="10%">{item?.sub_title}</TextTitle>

        <Row gutter={24} className="row-structure">
          <Col span={12} style={{ display: "flex", justifyContent: "center" }}>
            <TextHead>
              <img
                loading="lazy"
                src={ellipse1}
                alt="icon circle pink"
                style={{
                  zIndex: "-1",
                  position: "absolute",
                  left: "40px",
                  top: "0px",
                }}
              />
              พ้นสถานภาพ
            </TextHead>
            <Numbers>
              ต่ำกว่า
              <span>1.50</span>
            </Numbers>
          </Col>
          {/* <Col span={8} style={{ display: "flex", justifyContent: "center" }}>
            <TextHead>
              <img
                loading="lazy"
                src={ellipse3}
                alt="icon circle yellow"
                style={{
                  zIndex: "-1",
                  position: "absolute",
                  left: "7px",
                  top: "0px",
                }}
              />
              รอพินิจ
            </TextHead>
            <Numbers>
              <span>1.50 – 1.79</span>
            </Numbers>
          </Col> */}
          <Col span={12} style={{ display: "flex", justifyContent: "center" }}>
            <TextHead>
              <img
                loading="lazy"
                src={ellipse2}
                alt="icon circle green"
                style={{
                  zIndex: "-1",
                  position: "absolute",
                  left: "-9px",
                  top: "0px",
                }}
              />
              ปกติ
            </TextHead>
            <Numbers>
              <span>1.50</span>
              ขึ้นไป
            </Numbers>
          </Col>
        </Row>
        <div className="row-top">
          <TextDetail align="center">
            จำแนกสถานภาพทุกสิ้นภาคการศึกษาที่ 3 ของทุกปี หาก GPAX ต่ำกว่า 1.50
            จะพ้นสถานภาพ
          </TextDetail>
          <Row>
            <Col span={24}>
              <TableRe data={reEntryData[0]} />
              {/* <TableRe data={reEntryData[1]} /> */}
            </Col>
          </Row>
          <div style={{ marginTop: "20px" }}>
            <ListImage
              noteText={item?.conent_0}
              noteText1={item?.conent_1}
              type="note"
              font="Noto Sans Thai"
            />
          </div>
        </div>
      </Element>
    );
  };

  const renderReturn = (item) => {
    return (
      <Element name={item?.slung} id={item?.slung} ref={myRef}>
        <div style={{ marginTop: "20%" }}>
          <TextHead>
            <img
              loading="lazy"
              src={returnIncon}
              alt="icon return"
              style={{
                zIndex: "-1",
                position: "absolute",
                left: "-50px",
                top: "-30px",
                width: "104px",
              }}
            />
            {item?.title}
          </TextHead>
          <Row style={{ marginTop: "30px" }} className="row-system">
            <Col span={12}>
              <div style={styleStart}>
                <TextNumber>1</TextNumber>
                <TextDetail>
                  <div className="link-web re-entry">
                    ยื่นสมัคร Online ผ่านเว็บรับสมัคร
                    <a
                      href={`http://sutgateway.sut.ac.th/`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <u>sutgateway.sut.ac.th</u>
                    </a>
                  </div>
                </TextDetail>
              </div>
              <div style={styleStart}>
                <TextNumber>2</TextNumber>
                <TextDetail>
                  <div className="link-web re-entry">
                    นักศึกษาที่ยื่นใบสมัครเพื่อกลับเข้าศึกษาใหม่
                    ตรวจสอบคุณสมบัติผู้สมัคร โดยดูที่เว็บรับสมัคร
                    <a
                      href={`http://sutgateway.sut.ac.th/`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <u>sutgateway.sut.ac.th</u>
                    </a>
                  </div>
                </TextDetail>
              </div>
              <div style={styleStart}>
                <TextNumber>3</TextNumber>
                <TextDetail>{item?.conent_2}</TextDetail>
              </div>
              <div style={styleStart}>
                <TextNumber>4</TextNumber>
                <TextDetail>{item?.conent_3}</TextDetail>
              </div>
            </Col>
            <Col span={12}>
              <div style={styleStart}>
                <TextNumber>5</TextNumber>
                <TextDetail>{item?.conent_4}</TextDetail>
              </div>
              <div style={styleStart}>
                <TextNumber>6</TextNumber>
                <TextDetail>
                  ผู้ผ่านการคัดเลือก
                  อย่าลืมจ่ายค่าธรรมเนียมการดำเนินการรับกลับเข้าศึกษาใหม่
                  ภายในวันที่กำหนดอย่างเคร่งครัด
                </TextDetail>
              </div>
              <div style={styleStart}>
                <TextNumber>7</TextNumber>
                <TextDetail>{item?.conent_7}</TextDetail>
              </div>
            </Col>
          </Row>
          <div style={{ marginTop: "20px" }}>
            <ListImage
              noteText={item?.conent_6}
              type="note"
              font="Noto Sans Thai"
            />
          </div>
        </div>
      </Element>
    );
  };

  const renderEng = (item) => {
    return (
      <Element name={item?.slung} id={item?.slung} ref={myRef}>
        <FixBox bg="#FFF9EA">
          <Row className="row-col-branch">
            <Col span={11}>
              <FadeInSection axis="y">
                <img
                  src={item?.image}
                  alt="eng"
                  style={{ width: "100%" }}
                  loading="lazy"
                />
              </FadeInSection>
            </Col>
            <Col span={12} offset={1}>
              <TextTitle>{item?.sub_title}</TextTitle>
              {item?.conent_0 && (
                <Detail align="left" indent="32" bottom="0">
                  {item?.conent_0}
                </Detail>
              )}
              {item?.conent_1 && (
                <Detail align="left" indent="32" top="0">
                  {item?.conent_1}
                </Detail>
              )}
              {item?.conent_2 && (
                <Detail align="left" bottom="0">
                  {item?.conent_2}
                </Detail>
              )}
              {item?.conent_3 && (
                <Detail align="left" top="0" bottom="0">
                  {item?.conent_3}
                </Detail>
              )}
              {item?.conent_4 && (
                <Detail align="left" top="0">
                  {item?.conent_4}
                </Detail>
              )}
              {item?.conent_5 && (
                <Detail align="left" bottom="0">
                  {item?.conent_5}
                </Detail>
              )}
              {item?.conent_6 && (
                <Detail align="left" top="0" bottom="0">
                  {item?.conent_6}
                </Detail>
              )}
              {item?.conent_7 && (
                <Detail align="left" top="0">
                  {item?.conent_7}
                </Detail>
              )}
              {item?.conent_8 && (
                <Detail align="left" bottom="0">
                  {item?.conent_8}
                </Detail>
              )}
              {item?.conent_9 && (
                <Detail align="left" top="0">
                  {item?.conent_9}
                </Detail>
              )}
            </Col>
          </Row>
        </FixBox>
      </Element>
    );
  };

  const renderService = (item) => {
    return (
      <Element name={item?.slung} id={item?.slung} ref={myRef}>
        <TextTitle top="10%" center="center">
          ข้อมูลติดต่อศูนย์บริการการศึกษา
        </TextTitle>
        <Row gutter={24} className="row-service">
          <Col
            span={6}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {item?.image ? (
              <img
                loading="lazy"
                src={item?.image}
                alt="contact"
                style={{
                  borderRadius: "20px",
                  width: "100%",
                  marginBottom: "25px",
                }}
              />
            ) : (
              <img
                loading="lazy"
                src={rectangle1}
                alt="icon rectangle"
                style={{
                  borderRadius: "20px",
                  width: "100%",
                  marginBottom: "25px",
                }}
              />
            )}
          </Col>

          <Col span={9} style={{ padding: "10px" }}>
            <div style={styleDetailContact}>
              <DetailContact
                phone={item?.conent_0}
                time={`${item?.conent_1} | ${item?.conent_2}`}
                website={item?.conent_3}
              />
            </div>
          </Col>
          <Col span={9} style={{ padding: "10px" }}>
            <div style={styleDetailContact}>
              <DetailContact location={item?.conent_4} />
            </div>
          </Col>
        </Row>
      </Element>
    );
  };

  const styleDetailContact = { marginBottom: "30px" };

  return (
    <>
      <Container>
        <Row>
          <Col span={24}>
            <CusttomBreadcrumb>
              {splitPath.map((item, i) => {
                if (i !== splitPath.length - 1 && i !== 0) {
                  return (
                    <Breadcrumb.Item key={item}>
                      <Link to={newPath(item)}>{breadcrumbName[item]}</Link>
                    </Breadcrumb.Item>
                  );
                } else {
                  return (
                    <Breadcrumb.Item key={item}>
                      <Link to={newPath(item)}>{breadcrumbName[item]}</Link>
                    </Breadcrumb.Item>
                  );
                }
              })}
            </CusttomBreadcrumb>
          </Col>
        </Row>
        {isLoading ? (
          <>
            <Row>
              <Col span={24}>
                <Title className="animate__animated animate__slideInDown animate__slow">
                  {regisData?.page_th}
                </Title>
                <TitleEN className="animate__animated animate__flipInX animate__slow">
                  {regisData?.page_en}
                </TitleEN>
              </Col>

              <Col span={24} className="col-left-section">
                <Row gutter={24} className="row-section">
                  {regisData?.section &&
                    regisData?.section.length >= 0 &&
                    regisData?.section.map((item, index) => {
                      return (
                        <Col span={8} key={index}>
                          {renderLink(item?.slung, item?.title)}
                        </Col>
                      );
                    })}
                </Row>
              </Col>
            </Row>

            <FadeInSection axis="y">
              <img
                src={mainRegis}
                alt="registration"
                style={{ maxWidth: "100%", height: "auto" }}
                loading="lazy"
              />
            </FadeInSection>

            {regisData?.section &&
              regisData?.section.length >= 0 &&
              regisData?.section.map((item, index) => {
                return (
                  <div key={index}>
                    {item?.slung === "registration-system" &&
                      renderSystem(item)}
                    {item?.slung === "registered-credits" &&
                      renderCredits(item)}
                    {item?.slung === "registered-GPAX" && renderGPAX(item)}
                    {item?.slung === "registration-fees" && renderFees(item)}
                    {item?.slung === "branch-selection" &&
                      renderSelection(item)}
                    {item?.slung === "calculate-grade" && renderGrade(item)}
                    {item?.slung === "request-to-move-branch" &&
                      renderBranch(item)}
                    {item?.slung === "re-entry" && rendereEtry(item)}
                    {item?.slung === "retern-entry" && renderReturn(item)}
                    {item?.slung === "test-eng" && renderEng(item)}
                    {item?.slung === "service-center" && renderService(item)}
                  </div>
                );
              })}
          </>
        ) : (
          <LoadingSpin />
        )}
      </Container>
      <ScrollUpBtn />
    </>
  );
};

export default Registration;
